import { memo } from 'react';
import styles from './SearchQuick.module.css';
import { ReactComponent as LypaIcon } from '../../assets/lypa.svg';

interface SearchQuickProps {
  bottom?: number | string;
  onSearchClick?: () => void;
}

const SearchQuick = ({
  bottom = 'calc(32px + env(safe-area-inset-bottom, 0px))',
  onSearchClick,
}: SearchQuickProps) => {
  const handleClick = () => {
    onSearchClick?.();
  };

  return (
    <button
      className={styles.wrapper}
      type="button"
      style={{ bottom }}
      onClick={handleClick}
    >
      <LypaIcon className={styles.icon} />
    </button>
  );
};

export default memo(SearchQuick);

